import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';

import styles from './CircleRadio.module.css';
import { FeatureLock } from '../../../common/LockedFeatures';

function StyledRadio(props) {
    return (
        <Radio
            className={styles.radioButton}
            disableRipple
            color="default"
            checkedIcon={<span className={`${styles.radioButtonIcon} ${styles.radioButtonCheckedIcon}`} />}
            icon={<span className={styles.radioButtonIcon} />}
            {...props}
        />
    );
}

const CircleRadio = ({ handleCircleRadioChange, valuesList, radioValue, displayGrid }) => {
    const radioButtons = valuesList.map((listObj) => {
        const radioButton = (
            <FormControlLabel
                key={`circleRadio_${listObj.value}`}
                classes={{ label: styles.radioButtonLabel }}
                value={listObj.value}
                control={<StyledRadio />}
                label={listObj.label}
                disabled={listObj.disabled}
            />
        );

        if (listObj.lockedFeatureOptions) {
            return (
                <FeatureLock key={`circleRadioTooltip_${listObj.value}`} displayOptions={listObj.lockedFeatureOptions}>
                    {radioButton}
                </FeatureLock>
            );
        }

        return (
            <Tooltip
                key={`circleRadioTooltip_${listObj.value}`}
                disabled={!listObj.tooltip}
                title={listObj.tooltip || ''}
                arrow={true}
                placement="top"
                classes={{ tooltip: 'generic-tooltip' }}>
                {radioButton}
            </Tooltip>
        );
    });

    return (
        <RadioGroup
            className={displayGrid ? styles.circleRadioGroupGrid : styles.circleRadioGroup}
            name="circleRadio"
            value={radioValue}
            onChange={handleCircleRadioChange}>
            {radioButtons}
        </RadioGroup>
    );
};

export default CircleRadio;
